import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { CheckButtonResponse } from '../model/button-fields';
import { ContenedorDetail, Contenedores, ContenedorFiltroDTO } from '../model/inventories';
import { IPagination } from '../model/pagination';
import { UbicacionUnidadDocumental } from '../model/ubicacion-unidad-documental';

@Injectable()
export class AlmacenService {

  ALMACEN_PATH = environment.API_BASE + '/Almacen';

  constructor(private http: HttpClient) { }

  getUbicacionExpediente(idExpediente: number): Observable<UbicacionUnidadDocumental> {
    return this.http.get<UbicacionUnidadDocumental>(this.ALMACEN_PATH + '/ObtenerUbicacionExpediente/' + idExpediente)
      .pipe(map(data => UbicacionUnidadDocumental.toModel(JSON.stringify(data))));
  }

  getUbicacionContenedor(idExpediente: number): Observable<UbicacionUnidadDocumental> {
    return this.http.get<UbicacionUnidadDocumental>(this.ALMACEN_PATH + '/ObtenerUbicacionContenedor/' + idExpediente)
      .pipe(map(data => UbicacionUnidadDocumental.toModel(JSON.stringify(data))));
  }

  validateContainer(idContenedor: number, clienteId: number): Observable<CheckButtonResponse> {
    return this.http.get<number>(this.ALMACEN_PATH + '/ExistsContainer/' + clienteId + '/' + idContenedor)
      .pipe(map(data => CheckButtonResponse.toModel(JSON.stringify(data))));
  }

  searchInventarioContenedores(from: number, take: number, filter: ContenedorFiltroDTO): Observable<IPagination<Contenedores>> {
    const observable = this.http.post<any>(this.ALMACEN_PATH + '/FindContainer/' + from + '/' + take, filter)
      .pipe(map((paginationContenedoresList: IPagination<Contenedores>) =>
        IPagination.toModel<Contenedores>(JSON.stringify(paginationContenedoresList), Contenedores)));
    return observable as Observable<IPagination<Contenedores>>;
  }

  getContainerDetails(id: number): Observable<ContenedorDetail> {
    return this.http.get<ContenedorDetail>(this.ALMACEN_PATH + '/ObtenerDetalleContenedor/' + id)
      .pipe(map(data => ContenedorDetail.toModel(JSON.stringify(data))));
  }

}
